export const AT_CHECKLIST_ACTION_SET = 'CHECKLISTS_CHECKLIST_ACTION_SET';
export const AT_CHECKLIST_ADD = 'CHECKLISTS_CHECKLIST_ADD';
export const AT_CHECKLIST_DELETE = 'CHECKLISTS_CHECKLIST_DELETE';
export const AT_CHECKLISTS_SET = 'CHECKLISTS_SET';
export const AT_CHECKLISTS_UPDATE = 'CHECKLISTS_UPDATE';
